import TemplateView from '../../../TemplateView'
import {escapeHtmlSymbols} from '../../../atUtils'
import * as UserNameFormat from '../../../util/UserNameFormat'
import ScrollUtils from '../../../util/ScrollUtils'
import {fixIScrollInnerWheelEvent} from '../../../atBrowserUtils'

export default class ApproversDialog extends TemplateView {
    constructor() {
        super()

        this.state = {
            approvers: [],
        }

        this.onStatePropertyChanged("approvers", approvers => {
            this._updateView(approvers)
        })
    }

    templateHtml() {
        return "<div class='approversDialog'>" +
               "  <div class='text'><%-text%></div>" +
               "  <div class='managersListScrollableContainer'>"+
               "    <div class='managersList'></div>"+
               "  </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            text: "user.timetrack_settings.approvers_dialog.managers_with_access_to_user",
        }
    }

    afterRender() {
        this.$managersList = this.find('.managersList')
        this.managersListScroll = ScrollUtils.addVerticalScroll(this.find('.managersListScrollableContainer'), {})
        fixIScrollInnerWheelEvent(this.find('.managersListScrollableContainer'))
    }

    _updateView(approvers) {
        let _html = ""
        for (let i = 0; i < approvers.length; ++i) {
            let userInfo = approvers[i];
            _html += "<div class='manager'><div class='name'>" + escapeHtmlSymbols(UserNameFormat.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleInitial)) + "</div></div>";
        }

        this.$managersList.html(_html)
    }

    update() {
        super.update()
        ScrollUtils.refreshCustomScroll(this.managersListScroll)
    }

}


// WEBPACK FOOTER //
// ./web/js/panels/user/components/ApproversDialog.js